import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { services, billingStats, citizenStats } from '../data/mockData';
import { Button } from '../components/ui/Button';
import { StatCard } from '../components/ui/StatCard';
// Reusing the old PolicyDashboard content for DLRMS
function DlrmsBillingView() {
  const khatianData = billingStats.find(b => b.category === 'Khatian Application');
  const mouzaData = billingStats.find(b => b.category === 'Mouza Map');
  return <div className="space-y-8 animate-in fade-in duration-500" data-id="element-135">
      {/* Khatian Section */}
      <section data-id="element-136">
        <h2 className="text-lg font-semibold text-slate-700 mb-4 border-l-4 border-slate-800 pl-3" data-id="element-137">
          Khatian Application Information
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-138">
          <StatCard title="Total Applications" value={khatianData?.totalOrders.toLocaleString() || '0'} variant="slate" fullWidth data-id="element-139">
            <div className="grid grid-cols-2 gap-4 text-center" data-id="element-140">
              <div className="border-r border-white/20" data-id="element-141">
                <p className="text-sm opacity-80" data-id="element-142">Certified Copy</p>
                <p className="text-xl font-bold" data-id="element-143">
                  {khatianData?.certifiedCopies.toLocaleString()}
                </p>
              </div>
              <div data-id="element-144">
                <p className="text-sm opacity-80" data-id="element-145">Online Copy</p>
                <p className="text-xl font-bold" data-id="element-146">
                  {khatianData?.onlineCopies.toLocaleString()}
                </p>
              </div>
            </div>
          </StatCard>

          <StatCard title="Total Revenue (BDT)" value={`৳${khatianData?.totalRevenue.toLocaleString()}`} variant="purple" fullWidth data-id="element-147">
            <div className="grid grid-cols-2 gap-4 text-center" data-id="element-148">
              <div className="border-r border-white/20" data-id="element-149">
                <p className="text-sm opacity-80" data-id="element-150">Certified Copy</p>
                <p className="text-xl font-bold" data-id="element-151">
                  ৳{khatianData?.certifiedRevenue.toLocaleString()}
                </p>
              </div>
              <div data-id="element-152">
                <p className="text-sm opacity-80" data-id="element-153">Online Copy</p>
                <p className="text-xl font-bold" data-id="element-154">
                  ৳{khatianData?.onlineRevenue.toLocaleString()}
                </p>
              </div>
            </div>
          </StatCard>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-155">
          <StatCard title="Total Delivered" value={(khatianData?.deliveryMethod.post || 0) + (khatianData?.deliveryMethod.office || 0)} variant="green" data-id="element-156" />
          <StatCard title="Delivered via Post" value={khatianData?.deliveryMethod.post || 0} variant="pink" data-id="element-157" />
          <StatCard title="Delivered via Office" value={khatianData?.deliveryMethod.office || 0} variant="orange" data-id="element-158" />
          <StatCard title="Delivered via UDC" value={khatianData?.deliveryMethod.udc || 0} variant="lime" data-id="element-159" />
        </div>
      </section>

      {/* Mouza Map Section */}
      <section className="pt-6 border-t border-slate-200" data-id="element-160">
        <h2 className="text-lg font-semibold text-slate-700 mb-4 border-l-4 border-slate-800 pl-3" data-id="element-161">
          Mouza Map Application Information
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-162">
          <StatCard title="Total Applications" value={mouzaData?.totalOrders.toLocaleString() || '0'} variant="blue" data-id="element-163" />
          <StatCard title="Total Revenue" value={`৳${mouzaData?.totalRevenue.toLocaleString()}`} variant="green" data-id="element-164" />
          <StatCard title="Delivered via Post" value={mouzaData?.deliveryMethod.post || 0} variant="orange" data-id="element-165" />
        </div>
      </section>
    </div>;
}
function GenericBillingView({
  name
}: {
  name: string;
}) {
  return <div className="p-12 text-center bg-slate-50 rounded-lg border border-slate-200 border-dashed" data-id="element-166">
      <h3 className="text-xl font-semibold text-slate-700 mb-2" data-id="element-167">
        Billing Dashboard for {name}
      </h3>
      <p className="text-slate-500" data-id="element-168">
        Custom dashboard layout not yet configured for this service.
      </p>
    </div>;
}
export function BillingSystemDetails() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const service = services.find(s => s.uuid === id);
  if (!service) return <div data-id="element-169">Service not found</div>;
  return <div className="space-y-6" data-id="element-170">
      <div className="flex items-center space-x-4 mb-6" data-id="element-171">
        <Button variant="ghost" onClick={() => navigate('/billing')} className="p-2" data-id="element-172">
          <ArrowLeft className="w-5 h-5" data-id="element-173" />
        </Button>
        <div data-id="element-174">
          <h1 className="text-2xl font-bold text-slate-800" data-id="element-175">
            {service.name_en} Billing
          </h1>
          <p className="text-slate-500" data-id="element-176">Revenue & Transaction Details</p>
        </div>
      </div>

      {service.name_en === 'DLRMS' ? <DlrmsBillingView data-id="element-177" /> : <GenericBillingView name={service.name_en} data-id="element-178" />}
    </div>;
}